export const ACTIVITY_MARKER_CENTER_Y = 12;
export const ACTIVITY_MARKER_SIZE_DEFAULT = 36;
export const ACTIVITY_MARKER_SIZE_STATUS = 42;

import type { PurchaseOrderStatusCode } from '@/types/core/purchase-order/purchase-order';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';

// TODO only use code and not family
export const STATUS_EVENT_FAMILY = 'order_status';
export const DOCUMENT_EVENT_FAMILY = 'document';
export const COMMUNICATION_EVENT_FAMILY = 'communication';

export const SYNC_ACTIVITY_EVENT_CODE = 'purchase_order_lines_synced';
export const UPDATE_ACTIVITY_EVENT_CODE = 'purchase_order_lines_updated';
export const KEY_DATE_ACTIVITY_EVENT_CODES = [
  'purchase_order_lis_date_updated',
  'purchase_order_eta_date_updated',
  'purchase_order_eop_date_updated',
  'purchase_order_etd_date_updated',
];

export const DOCUMENT_LIKE_ACTIVITY_EVENT_FAMILIES = [
  DOCUMENT_EVENT_FAMILY,
  COMMUNICATION_EVENT_FAMILY,
] as const;

export const TIMELINE_ACTIVITY_EVENT_FAMILIES = [
  STATUS_EVENT_FAMILY,
  ...DOCUMENT_LIKE_ACTIVITY_EVENT_FAMILIES,
] as const;

export const TIMELINE_ACTIVITY_EVENT_CODES = [
  SYNC_ACTIVITY_EVENT_CODE,
  UPDATE_ACTIVITY_EVENT_CODE,
] as const;

export const PRODUCTION_DECLARATION_SENT_ACTIVITY_EVENT_CODES = [
  'production_declaration_requested',
  'production_declaration_approve_email_sent',
  'production_declaration_refuse_email_sent',
] as const;

// TODO Try to use existing config for PO status badge
export const PURCHASE_ORDER_ACTIVITY_STATUS_CODES: PurchaseOrderStatusCode[] = [
  'ORDER_CREATION',
  'WAITING_FOR_SUPPLIER_AGREEMENT',
  'SUPPLIER_AGREEMENT_RECEIVED',
  'IN_PRODUCTION',
  'IN_ADJUSTMENTS',
  'END_OF_PRODUCTION',
  'CLOSED',
  'CANCELLED',
];

const PURCHASE_ORDER_ACTIVITY_STATUS_COLOR_CLASS_BY_CODE: Record<
  PurchaseOrderStatusCode,
  string
> = {
  ORDER_CREATION: 'bg-gray-400',
  WAITING_FOR_SUPPLIER_AGREEMENT: 'bg-sky-600',
  SUPPLIER_AGREEMENT_RECEIVED: 'bg-green-600',
  IN_PRODUCTION: 'bg-sky-800',
  IN_ADJUSTMENTS: 'bg-amber-600',
  END_OF_PRODUCTION: 'bg-emerald-600',
  CLOSED: 'bg-gray-600',
  CANCELLED: 'bg-red-600',
};

export function isPurchaseOrderActivityStatusCode(
  value: string,
): value is PurchaseOrderStatusCode {
  return PURCHASE_ORDER_ACTIVITY_STATUS_CODES.includes(
    value as PurchaseOrderStatusCode,
  );
}

export function getPurchaseOrderActivityStatusColorClass(
  value: string | null,
  fallbackClassName = 'bg-gray-400',
) {
  if (!(value && isPurchaseOrderActivityStatusCode(value))) {
    return fallbackClassName;
  }

  return PURCHASE_ORDER_ACTIVITY_STATUS_COLOR_CLASS_BY_CODE[value];
}

export function isProductionDeclarationActivityEventCode(
  eventCode: string,
): eventCode is (typeof PRODUCTION_DECLARATION_SENT_ACTIVITY_EVENT_CODES)[number] {
  return PRODUCTION_DECLARATION_SENT_ACTIVITY_EVENT_CODES.includes(
    eventCode as (typeof PRODUCTION_DECLARATION_SENT_ACTIVITY_EVENT_CODES)[number],
  );
}

export function isPurchaseOrderTimelineActivity(
  activity: PurchaseOrderActivityItem,
) {
  return (
    TIMELINE_ACTIVITY_EVENT_FAMILIES.includes(
      activity.eventFamily as (typeof TIMELINE_ACTIVITY_EVENT_FAMILIES)[number],
    ) ||
    TIMELINE_ACTIVITY_EVENT_CODES.includes(
      activity.eventCode as (typeof TIMELINE_ACTIVITY_EVENT_CODES)[number],
    ) ||
    KEY_DATE_ACTIVITY_EVENT_CODES.includes(
      activity.eventCode as (typeof KEY_DATE_ACTIVITY_EVENT_CODES)[number],
    )
  );
}
